import { Box, Stack, Typography } from '@mui/material';

import { CloseButton } from '@/components/form/baseInputs/Button/CloseButton';
import { Callout } from '@/components/notifications/Callout/Callout';

interface AISuggestionReviewProcessingBannerProps {
  suggestionTypeText: string;
  /** When true, shows "Suggestions generating" copy instead of "Documents processing". */
  isHouseholdRegen?: boolean;
  showReviewMessage?: boolean;
  onDismiss?: () => void;
}

export function AISuggestionReviewProcessingBanner({
  suggestionTypeText,
  isHouseholdRegen = false,
  showReviewMessage = true,
  onDismiss,
}: AISuggestionReviewProcessingBannerProps) {
  const title = isHouseholdRegen
    ? 'Suggestions generating'
    : 'Documents processing';
  const description = isHouseholdRegen
    ? `Luminary AI is regenerating ${suggestionTypeText} for this household`
    : `Luminary AI is attempting to identify ${suggestionTypeText} from recently uploaded documents`;

  return (
    <Callout severity="success" skipTextWrapper>
      <Stack direction="row" alignItems="center" spacing={2} width="100%">
        <Box flex={1}>
          <Typography component="div" variant="title-xs" paddingBottom={0.5}>
            {title}
          </Typography>
          <Typography component="div" variant="body-xs">
            {description}
            {showReviewMessage &&
              ' — results will display here when ready for your review.'}
          </Typography>
        </Box>
        {onDismiss && (
          <CloseButton
            size="xs"
            aria-label={`Dismiss ${title.toLowerCase()}`}
            onClick={onDismiss}
          />
        )}
      </Stack>
    </Callout>
  );
}
